/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.createCommunity'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  visibility: /*#__PURE__*/ l.string<{
    knownValues: ['public', 'restricted', 'invite-only', 'private']
  }>(),
  name: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 120 }),
  description: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 1000 }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  uri: /*#__PURE__*/ l.string(),
  authorityDid: /*#__PURE__*/ l.string({ format: 'did' }),
  ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
  visibility: /*#__PURE__*/ l.string<{
    knownValues: ['public', 'restricted', 'invite-only', 'private']
  }>(),
  name: /*#__PURE__*/ l.string(),
  description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create a community with an explicit public, restricted, invite-only, or private boundary. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
